import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['authentication_user']),
    },
    methods: {
        isInternalCompetitor(competitorName) {
            const normalize = (str) => {
                if (!str) return '';
                return str.toLowerCase().replace(/\s+/g, '').trim();
            };
            const normalized = normalize(competitorName);
            const clientName = normalize(this.authentication_user.client_name);
            const businessName = normalize(this.authentication_user.client_business_select);
            return normalized === clientName || normalized === businessName;
        }
    }
};
